import { BasicAlert } from '../alert';

export const NoData = ({ text }: { text: string }) => (
  <div className='mr-3'>
    <BasicAlert type='warning'>{text}</BasicAlert>
  </div>
);
